import React from 'react'
import { connect } from 'react-redux'
import css from './style.css'
import {Grid, GridItem} from '../grid'
import Label from '../label'
import Input from '../input'
import OrderTally from '../order-tally'
import { cartFieldChanged } from '../../actions/cart'

const mapStateToProps = (state, ownProps) => {
  return {
    clientNoteField: state.cart.clientNotes,
    salesNoteField: state.cart.salesNotes
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    cartFieldChanged: (field, value) => {
      dispatch(cartFieldChanged(field, value.target.value))
    }
  }
}

const OrderSummary = props => (
  <Grid>
    <GridItem col='2/5'>
      <Label>Client Notes</Label>
      <Input type='textarea' value={props.clientNoteField} onChange={props.cartFieldChanged.bind(this, 'clientNotes')} rows={5} placeholder='Client Notes' pad />
      <Label>Production Notes</Label>
      <Input type='textarea' value={props.salesNoteField} onChange={props.cartFieldChanged.bind(this, 'salesNotes')} rows={5} placeholder='Production Notes' pad />
    </GridItem>
    <GridItem col='1/5' />
    <GridItem col='2/5'>
      <p className={css.header}>Order Information</p>
      <OrderTally />
    </GridItem>
  </Grid>
)

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary)



// WEBPACK FOOTER //
// ./src/components/order-summary/index.js